import React, { Fragment, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./components/auth/Login";
import Routes from "./components/routing/Routes";
import "materialize-css/dist/css/materialize.min.css";
import M from "materialize-css/dist/js/materialize.min.js";
import ResponseInterceptor from "../src/utils/interceptor";
//Redux
import { connect } from "react-redux";
import { LOGIN_SUCCESS, GET_TENANT_INFO } from "./action/types";
import setAuthToken from "./utils/setAuthToken";
import setTenantId from "./utils/setTenantId";
import "./App.css";
import CircularProgress from "@material-ui/core/CircularProgress";
// import "./color.css";

const App = ({ tenantInfo, dispatch }) => {

  const [appReady, setAppReady] = useState(false);
  useEffect(() => {
    // Init Materialize JS
    M.AutoInit();
    ResponseInterceptor();

    const storedAuth = localStorage.getItem("authInfo");
    const tenantInfo = localStorage.getItem("tenantInfo")

    if(tenantInfo){
      dispatch({
          type: GET_TENANT_INFO,
          payload: JSON.parse(tenantInfo),
        });
        setTenantId(tenantInfo.tenantId);
    }

    if (storedAuth) {
      const parsedAuth = JSON.parse(storedAuth);
      dispatch({ type: LOGIN_SUCCESS, payload: parsedAuth });
      setAuthToken(parsedAuth.accessToken);
    }

    setAppReady(true);

  }, [dispatch]);

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.setAttribute("href",tenantInfo.tenantFaviconUrl)
    // favicon.href = logo;
  }, [tenantInfo.tenantFaviconUrl]);
  let className = "main-wrapper ";
  if (tenantInfo.primaryColor) {
    className +=
      tenantInfo.primaryColor +
      "-theme " +
      tenantInfo.secondaryColor +
      "-theme-secondary ";
  } else {
    className += "blue-theme lime-theme-secondary ";
  }
  if (
    tenantInfo.selectedTheme &&
    ["round", "rectangular"].includes(tenantInfo.selectedTheme.toLowerCase())
  ) {
    className += tenantInfo.selectedTheme.toLowerCase() + " roundOrRectangular";
  }
  if (!appReady) {
    return (
            <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  height: "80vh",
                }}
              >
                <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
            </div>
            );
  }


  return (
    <Router>
      <Fragment>
        <section className={className}>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route component={Routes} />
          </Switch>
        </section>
      </Fragment>
    </Router>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantInfo: state.tenant.tenantInfo,
  };
};

export default connect(mapStateToProps)(App);
